<template>
  <div class="wrapper">

    <div class="top">
      <div class="tabs">
        <div
          class="tab"
          v-for="(item,index) in orderTypes"
          :key="index"
          @click="changeOrderType(index)"
          :class="{'active':statusIndex==index}"
        >{{item}}</div>
      </div>
    </div>

      <div class="time-tips" v-if="orderList.length">当前页面拍品状态和价格可能延迟，请点击拍品查看实时状态。不支付、取消订单或发货前退款的，视为放弃，将会流转给下位竞拍人</div>

    <div class="order-wrap">
      <div class="order-head order-box">
        <div class="order-info">拍品</div>
        <div class="order-price">当前竞拍价</div>
        <div class="order-num">竞拍状态</div>
        <div class="order-state">操作</div>
        <!-- <div class="order-handle">操作</div> -->
      </div>


      <div v-if="orderList.length==0" class="no-order">
        <div v-show="statusIndex>0">没有{{orderTypes[statusIndex]}}的竞拍</div>
        <div v-show="statusIndex==0">没有竞拍信息，快去去参加竞拍吧~</div>
      </div>



      <div v-show="orderList.length>0">
        <div class="order-item" v-for="(order,index) in orderList" :key="index">


          <div class="order-item-head">
            <span class="time">{{order.ctime}}</span>
            报名编号：
            <span class="code">{{order.id}}</span>

          </div>


          <div class="order-item-main order-box">
            <div class="order-info-list">

              <div class="order-li" @click="detail(order)">
                <img v-lazy="order.auction.cover_img_src" alt class="order-img">
                <div class="order-name">
				<div class="order-auction-name">{{order.auction.name}}</div>
				<div class="order-auction-status">
					【{{order.auction.auction_status_text}}】
				</div>
				
				</div>
                <div class="order-price">￥{{order.auction.current_auction_price}}</div>
              </div>
            </div>


            <div class="order-num">
              <div class="count-down">
				  
                <span class="count-down-span">
				<router-link class="txt" :to="{name :'auction',params: {goodsId:order.auction.id}}">{{order.offer_status}}</router-link>
				</span>       
              </div>
            </div>

            <div class="order-handle">
                <div class="footer-button">

					<router-link class="txt" :to="{name :'auction',params: {goodsId:order.auction.id}}"
					v-if="order.auction_status == 1 ">报名成功</router-link>
                   <!-- <span class="txt" v-if="order.auction_status == 1">报名成功</span> -->
					<router-link class="txt" :to="{name :'auction',params: {goodsId:order.auction.id}}"
					v-if="order.auction_status == 2 ">{{order.auction_status_text}}</router-link>
					
					
                    <router-link class="txt" v-if="order.auction_status == 5 && order.bond_money>0 && order.order_id && order.user_giveup==0" :to="{name :'orderDetail',params: {order_id:order.order_id}}">已获拍 已退保证金</router-link>
					<router-link class="txt" v-if="order.auction_status == 5 && order.bond_money>0 && !order.order_id && order.user_giveup==0 " :to="{name :'auction',params: {goodsId:order.auction.id}}">已退保证金</router-link>
					<router-link class="txt" v-if="order.auction_status == 5 && order.bond_money<=0 && order.order_id && order.user_giveup==0 " :to="{name :'orderDetail',params: {order_id:order.order_id}}">已获拍</router-link>
					<router-link class="txt" v-if="order.auction_status == 5 && order.bond_money<=0 && !order.order_id && order.user_giveup==0 " :to="{name :'auction',params: {goodsId:order.auction.id}}">报名成功</router-link>
					<router-link class="txt" v-if="order.auction_status == 5 && order.bond_money>0 && !order.order_id && order.user_giveup!=0 " :to="{name :'auction',params: {goodsId:order.auction.id}}">已退保证金</router-link>
					
					<!-- <router-link class="txt" :to="{name :'auction',params: {goodsId:order.auction.id}}"
					v-if="order.auction_status == 1">参拍状态：{{order.offer_status}}</router-link> -->
					
                    <span class="txt" v-if="order.auction_status == 6">已放弃购买</span>

                    <div class="btn-wrap"  v-if="order.auction_status == 2 || order.auction_status == 3">
                     <router-link class="btn submit" :to="{name :'auction',params: {goodsId:order.auction.id}}" 
                     v-if="order.auction_status == 1 && order.auction.auction_status == 2">继续出价</router-link>
                   <div class="btn cancle" @click="cancle(order.auction.id,order.auction)" v-if="order.auction_status == 3 && order.auction.auction_status == 3 && order.pay_timeout_status">放弃支付</div>
					&nbsp;
					
 <div class="btn submit" @click="buyNow(order)" v-if="order.auction_status == 3 && order.auction.auction_status == 3 && order.pay_timeout_status">立即支付</div>
                  </div>
                  
                  <div class="btn-wrap"   v-if="order.auction_status == 4">

                     <router-link class="txt" :to="{name :'orderDetail',params: {order_id:order.order_id}}" >订单详情 </router-link>
                  </div>



                   <!-- <router-link class="btn submit" :to="{name :'auction',params: {goodsId:order.auction.id}}" 
                      >{{auction_status[order.auction_status]}}</router-link>


                    <div class="btn-wrap">

                      <router-link class="btn submit" :to="{name :'auction',params: {goodsId:order.auction.id}}" 
                      v-if="order.auction_status == 2 
                                      && order.auction.auction_status == 2">继续出价</router-link>

                      <router-link class="btn submit" :to="{name :'auction',params: {goodsId:order.auction.id}}" 
                      v-if="order.auction_status == 3 
                                      && order.auction.auction_status == 3 && order.pay_timeout_status">立即支付</router-link>
                    </div> -->
                </div>
            </div>


            <!-- <div class="order-state">
              <div class="order-status">{{getOrderStatus(order)}}</div>
              <router-link
                :to="{name:'orderDetail',params:{order_id:order.order_id}}"
                class="order-detail-link"
                tag="a"
              >订单详情</router-link>
            </div> -->
          </div>
        </div>
        <Pagination :totalPage="totalPage" :limit="limit" @changePage="handOrderMore"></Pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, hideLoading } from '../../utils/loading'
import Pagination from "@/components/common/Pagination.vue";
import Timedown from "@/components/timedown.vue";

import { timeToDate, isSafeRedirect } from "@/utils";
export default {
  name: "MyOrder",
  components: { Pagination, Timedown },
  props: {},
  data() {
    return {
      orderTypes: ["我的竞拍", "待交保","参拍中", "已中标", "已获拍","未获拍","已弃拍"],
      keyword: "",
      statusIndex: 0,
      orderList: [],
      totalPage: 0,
      page: 1,
      limit: 10,
      auction_status: {
          1: '报名成功',
          2: '报名未付款',
          3: '竞拍成功',
          4: '已生成订单',
          5: '已退保证金',
          6: '超时未付款'
      }
    };
  },
  watch: {
    statusIndex(){
      this.initData();
      this.$route.query.type=this.statusIndex;
    }
  },
  computed: {
    orderTime() {
      return time => {
        return timeToDate(time);
      };
    },
    //获取订单状态文字显示
    getOrderStatus() {
      return order => {
        let orderStatusName;
        switch (order.status) {
          case 1:
            if (order.pay_status === 1) {
              orderStatusName = "待付款";
            }
            if (order.pay_status === 2 && order.ship_status === 1) {
              orderStatusName = "待发货";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 1
            ) {
              orderStatusName = "待收货";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 1
            ) {
              orderStatusName = "待评价";
            }
            if (
              order.pay_status === 2 &&
              order.ship_status === 3 &&
              order.confirm === 2 &&
              order.is_comment === 2
            ) {
              orderStatusName = "已评价";
            }
            if (order.pay_status === 4) {
              orderStatusName = "售后单";
            }
            break;
          case 2:
            orderStatusName = "已完成";
            break;
          case 3:
            orderStatusName = "已取消";
            break;
        }
        return orderStatusName;
      };
    }
  },
  methods: {
    buyNow(order) {

      let data = {
					product_id: order.auction.product_id,
					nums: 1,
					type: 2,
					order_type: 12, //拍卖
					params: JSON.stringify({ auction_id: order.auction_id })
				};
				this.$api.addCart(data).then(res => {
					if (res.status) {
						this.dialogVisible = false;
						let cartIds = res.data;
						this.$router.push({
							name: 'order',
							query: {
								cart_ids: JSON.stringify(cartIds),
								ordertype: 12,
								auctionid: order.auction_id
							}
						});
					} else {
						this.$message({
							message: res.msg,
							type: 'error'
						});
						return;
					}
				});


      // // return
      // let params = {
      //   order_id: order.order_id || order.id,
      //   type: 10,
      //   goodsId: order.auction.product_id
      // }
      // this.$router.push({
      //   name: 'cashier',
      //   params
      // });
    },
    detail(val) {
     let { href } =  this.$router.resolve({
        name: 'auction',
        params: {goodsId:val.auction.id}
      })
      if (!isSafeRedirect(href)) {
        console.warn('非白名单域名，禁止跳转:', href);
        return;
      }
			window.open(href, '_blank')
    },
	inputChange() {
	},
    initData() {
      this.orderList = [];
      this.getOrderList();
    },
    changeOrderType(index) {
      if (this.statusIndex == index) return;
      this.statusIndex = index;
	  showLoading();
    },
    //分页加载
    handOrderMore(val) {
      this.page = val;
      this.getOrderList();
    },
    //确认收货
    tackDelivery(order_id) {
      this.$confirm("确定已收到宝贝?", "提示", {
        confirmButtonspan: "确定",
        cancelButtonspan: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          order_id: order_id
        };
        this.$api.confirmOrder(data).then(res => {
          if (res.status) {
            this.$msg("确认收货成功!");
            this.getOrderList();
          }
        });
      });
    },
	searchOrder(){
		this.getOrderList();
	},
    getOrderList() {
      let data = {
        page: this.page,
        limit: this.limit,
        enroll_auction_status: this.statusIndex
      };
      this.$api.enrollList(data).then(res => {
        if (res.status) {
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.limit)
          );
          this.orderList = res.data.list;
        }
		hideLoading();
      });
    },
	cancle(auction_id,auction) {
		const _this = this;
		let msg = "是否真的放弃本次竞拍成功资格? 如确定本次中标将顺延。";
		if(auction.need_bond == 1){
			msg = "是否真的放弃竞拍成功资格？本拍品有保证金，若放弃竞拍，保证金将不予退回，本次中标资格将顺延。";
		}
		_this.$confirm(msg).then(_ => {
			_this.$api.giveUpAuction({ auction_id: auction_id }).then(res => {
				if (!res.status) {
					
					_this.$message({
						message: res.msg,
						type: 'error'
					});
					return;
				}else{
					window.location.reload()
				}
			});
		});
	}
  },
  created() {},
  mounted() {
	showLoading();
    this.initData();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.time-tips{
		background-color:#fcf9da;
		padding: 10px 10px;
		color: #e36a1b;
		font-size: 14px;
		z-index: 10;
    margin-bottom: 10px;
    margin-top: 20px
	}
.order-item {
  border: 1px solid $border;
  box-sizing: border-box;
  margin-bottom: 20px;
  .order-item-head {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    color: #757575;
    padding-left: 20px;
    border-bottom: 1px solid $border;
    .time {
      margin-right: 30px;
    }
  }
}
.order-box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  &.order-item-main {
    height: 100%;
    .order-info-list {
      border-right: 1px solid $border;
      width: 500px;
      .order-li {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:not(:last-of-type) {
          border-bottom: 1px solid $border;
        }
        .order-img {
          display: block;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }
        .order-name {
          width: 260px;
          line-height: 20px;
		  .order-auction-name{
			  display: -webkit-box;
			  -webkit-box-orient: vertical;
			  -webkit-line-clamp: 2;
			  overflow: hidden;
		  }
		  .order-auction-status{
			  color: #FF7159;
		  }
        }
      }
    }
  }
  &.order-head {
    @include line-height(40px);
    border-top: 1px solid $border;
    border-bottom: 1px solid $border;
    margin: 20px 0;
  }
  .order-info {
    width: 260px;
    span-indent: 20px;
  }
  .order-price {
    width: 100px;
    span-align: center;
  }
  .order-num {
    width: 90px;
    span-align: center;
    .icon {
      font-size: 12px;
    }
  }
  .order-total-price {
    width: 120px;
    span-align: center;
  }
  .order-state {
    width: 150px;
    span-align: center;
    .order-status {
      margin-bottom: 10px;
    }
    .order-detail-link {
      &:hover {
        color: $theme-color;
      }
    }
  }
  .order-handle {
    width: 150px;
    span-align: center;
    span,
    a {
      padding: 5px 0;
      cursor: pointer;
      &:hover {
        color: $theme-color;
      }
    }

    span {
      cursor: initial;
    }
  }
}
.wrapper {
  .top {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    align-items: center;
    .tabs {
      .tab {
        float: left;
        padding: 0 20px;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
        &:first-of-type {
          padding-left: 0;
        }
        &:not(:last-of-type) {
          border-right: 1px solid $border;
        }
        &.active {
          color: $theme-color;
        }
        span {
          color: $theme-color;
        }
      }
    }
    .search {
      width: 355px;
      height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(220, 220, 220, 1);
      padding: 10px 0 10px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.2s;
      position: relative;
	  .close-btn {
		  position: absolute;
		  right: 50px;
		  top: 50%;
		  transform: translateY(-50%);
		  width: 20px;
		  height: 20px;
	  }
      &.active {
        border: 1px solid $theme-color;
      }
      .search-input {
        display: block;
        flex: 1;
        height: 20px;
      }
      .search-icon-wrap {
        display: inline-block;
        width: 40px;
        height: 40px;
        position: relative;
        border-left: 1px solid rgba(220, 220, 220, 1);
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          color: #fff;
          background: $theme-color;
        }
        &.active {
          border-color: $theme-color;
        }
        .search-icon {
          position: absolute;
          width: 20px;
          height: 20px;
          top: 10px;
          left: 10px;
          .el-icon-search {
            font-size: 20px;
          }
        }
      }
    }
  }
}
.no-order {
  height: 100px;
  line-height: 100px;
  span-align: center;
  font-size: 18px;
}



.footer-button {
    font-size: 14px;

    .btn-wrap {
        margin-top: 10px;
        .btn {
            color: #ff1f44;
            cursor: pointer;
        }
    }

    .txt {
        color: #f78513;
        margin-bottom: 10px;
        display: inline-block;
    }
}
.btn.submit{
  cursor: pointer;
}
.btn-wrap{
	display: flex;
}
.btn-wrap .cancle{
	color:#757575 !important;
}
</style>